var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6375 0C39.18 0 41.25 2.116 41.25 4.738V46L36.4125 41.63L33.69 39.054L30.81 36.317L32.0025 40.572H6.4875C3.945 40.572 1.875 38.456 1.875 35.834V4.738C1.875 2.116 3.945 0 6.4875 0L36.6375 0ZM27.9525 30.038C32.925 29.877 34.8375 26.542 34.8375 26.542C34.8375 19.136 31.5975 13.133 31.5975 13.133C28.3575 10.649 25.275 10.718 25.275 10.718L24.96 11.086C28.785 12.282 30.5625 14.007 30.5625 14.007C28.2225 12.696 25.9275 12.052 23.79 11.799C22.17 11.615 20.6175 11.661 19.245 11.845L18.8625 11.891C18.075 11.96 16.1625 12.259 13.755 13.34C12.9225 13.731 12.4275 14.007 12.4275 14.007C12.4275 14.007 14.295 12.19 18.345 10.994L18.12 10.718C18.12 10.718 15.0375 10.649 11.7975 13.133C11.7975 13.133 8.5575 19.136 8.5575 26.542C8.5575 26.542 10.4475 29.877 15.42 30.038C15.42 30.038 16.2525 29.003 16.9275 28.129C14.07 27.255 12.99 25.415 12.99 25.415L13.62 25.806L13.71 25.875L13.7981 25.9268L13.8244 25.9382L13.9125 25.99C14.475 26.312 15.0375 26.565 15.555 26.772C16.4775 27.14 17.58 27.508 18.8625 27.761C20.55 28.083 22.53 28.198 24.69 27.784C25.7475 27.6 26.8275 27.278 27.9525 26.795C28.74 26.496 29.6175 26.059 30.54 25.438C30.54 25.438 29.415 27.324 26.4675 28.175C27.1425 29.049 27.9525 30.038 27.9525 30.038ZM17.49 19.297C16.2075 19.297 15.195 20.447 15.195 21.85C15.195 23.253 16.23 24.403 17.49 24.403C18.7725 24.403 19.785 23.253 19.785 21.85C19.8075 20.447 18.7725 19.297 17.49 19.297ZM25.7025 19.297C24.42 19.297 23.4075 20.447 23.4075 21.85C23.4075 23.253 24.4425 24.403 25.7025 24.403C26.985 24.403 27.9975 23.253 27.9975 21.85C27.9975 20.447 26.985 19.297 25.7025 19.297Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.570b1fb849e5e7064a4a588d738bef8a.svg";
export { ForwardRef as ReactComponent };